var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app d-flex flex-column" },
    [
      _c(
        "div",
        {
          staticClass:
            "body align-self-center d-flex flex-column justify-content-center align-items-center"
        },
        [
          _c("div", { staticClass: "logo-container" }, [
            _c("div", {
              staticClass: "signin-logo mb-4",
              domProps: { innerHTML: _vm._s(_vm.svg.logo) }
            })
          ]),
          _vm._v(" "),
          _c(
            "b-card",
            {
              staticClass:
                "p-4 mb-0 input-card d-flex flex-column align-items-stretch",
              attrs: { "no-body": "" }
            },
            [
              _c("b-card-body", [
                _c(
                  "div",
                  [
                    _c(
                      "div",
                      { staticClass: "language-select" },
                      [_c("Language")],
                      1
                    ),
                    _vm._v(" "),
                    _c("h4", [_vm._v(_vm._s(_vm.$t("AUTH.RESET_PASSWORD")))]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("AUTH.NEW_PASSWORD")))]),
                    _vm._v(" "),
                    _c(
                      "b-input-group",
                      { staticClass: "mb-3" },
                      [
                        _c("div", { staticClass: "input-group-prepend" }, [
                          _c("span", { staticClass: "input-group-text" }, [
                            _c("i", { staticClass: "fa fa-user" })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.resetPassword,
                              expression: "resetPassword"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.$v.resetPassword.$error,
                            "is-valid": !_vm.$v.resetPassword.$invalid
                          },
                          attrs: {
                            type: "password",
                            placeholder: _vm.$t("AUTH.NEW_PASSWORD")
                          },
                          domProps: { value: _vm.resetPassword },
                          on: {
                            blur: function($event) {
                              _vm.$v.resetPassword.$touch()
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.resetPassword = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        !_vm.$v.resetPassword.minLength
                          ? _c("b-form-invalid-feedback", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("AUTH.INVALID_PASSWORD", {
                                    MINIMUM:
                                      _vm.$v.resetPassword.$params.minLength.min
                                  })
                                )
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("AUTH.CONFIRM_PASSWORD")))]),
                    _vm._v(" "),
                    _c(
                      "b-input-group",
                      { staticClass: "mb-3" },
                      [
                        _c("div", { staticClass: "input-group-prepend" }, [
                          _c("span", { staticClass: "input-group-text" }, [
                            _c("i", { staticClass: "fa fa-user" })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.confirmResetPassword,
                              expression: "confirmResetPassword"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.$v.confirmResetPassword.$error,
                            "is-valid": !_vm.$v.confirmResetPassword.$invalid
                          },
                          attrs: {
                            type: "password",
                            placeholder: _vm.$t("AUTH.CONFIRM_PASSWORD")
                          },
                          domProps: { value: _vm.confirmResetPassword },
                          on: {
                            blur: function($event) {
                              _vm.$v.confirmResetPassword.$touch()
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.confirmResetPassword = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        !_vm.$v.confirmResetPassword.sameAsPassword
                          ? _c("b-form-invalid-feedback", [
                              _vm._v(_vm._s(_vm.$t("AUTH.IDENTICAL_PASSWORD")))
                            ])
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { staticClass: "text-center", attrs: { cols: "12" } },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "login-btn",
                                attrs: {
                                  variant: "secondary",
                                  disabled: _vm.$v.$invalid
                                },
                                on: { click: _vm.changePassword }
                              },
                              [_vm._v(_vm._s(_vm.$t("AUTH.RESET_PASSWORD")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "action-btn-container" },
                      [
                        _c(
                          "b-col",
                          { staticClass: "text-center", attrs: { cols: "12" } },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "px-0 mt-2",
                                attrs: { variant: "link" },
                                on: { click: _vm.loginClicked }
                              },
                              [_c("h5", [_vm._v(_vm._s(_vm.$t("AUTH.LOGIN")))])]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("Footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f3fb2dd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f3fb2dd","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/ResetPassword.vue
// module id = 1063
// module chunks = 2